import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  align-items: center;
  background-color: #fdb34d;
  color: ${({ theme }) => theme.colors.white};
  display: flex;
  flex-flow: row nowrap;
  font-size: 13px;
  gap: 10px;
  height: 60px;
  justify-content: center;
  padding: 10px;
`;

type ButtonProps = {
  secondary?: boolean;
};
export const Button = styled.button<ButtonProps>`
  background: transparent;
  border: solid 2px rgba(0, 0, 0, 0.3);
  border-radius: 3px;
  height: 30px;
  min-width: 100px;
  opacity: 0.8;
  padding: 0 10px;
  text-align: center;

  &:hover {
    opacity: 1;
  }

  ${({ secondary }) =>
    !secondary &&
    css`
      background-clip: padding-box;
      background-color: rgba(0, 0, 0, 0.3);
    `};
`;
